import React from 'react';
import { MessageCircle, Bot, Clock, Sparkles, ArrowRight } from 'lucide-react';

export default function Welcome({ onIniciar }) {
  return (
    <div className="min-h-screen flex items-center justify-center p-4 bg-gradient-to-br from-slate-950 via-slate-900 to-slate-950">
      <div className="w-full max-w-sm bg-slate-800/60 backdrop-blur-sm border border-slate-700/60 rounded-3xl p-7 shadow-2xl">
        <div className="flex flex-col items-center text-center mb-5">
          <div className="w-14 h-14 rounded-2xl bg-blue-500/15 border border-blue-500/30 flex items-center justify-center mb-3">
            <MessageCircle className="text-blue-400" size={28} />
          </div>
          <h1 className="text-xl font-bold text-white">Chat de Rocharamas</h1>
          <p className="text-slate-400 text-sm mt-1">
            ¡Bienvenido! Tu asistente para resolver dudas al instante.
          </p>
        </div>

        <div className="mb-5 rounded-2xl bg-slate-900/50 border border-slate-700/50 p-4">
          <p className="text-slate-300 text-sm leading-relaxed mb-3">
            Pregunta lo que necesites sobre nuestros productos y servicios. Un
            asistente con IA te responde al momento y, si hace falta, nuestro
            equipo continúa la conversación.
          </p>
          <ul className="space-y-2">
            <li className="flex items-start gap-2 text-slate-400 text-xs">
              <Bot size={15} className="text-blue-400 shrink-0 mt-0.5" />
              Respuestas inmediatas con inteligencia artificial.
            </li>
            <li className="flex items-start gap-2 text-slate-400 text-xs">
              <Sparkles size={15} className="text-blue-400 shrink-0 mt-0.5" />
              Atención de nuestro equipo cuando lo necesites.
            </li>
            <li className="flex items-start gap-2 text-slate-400 text-xs">
              <Clock size={15} className="text-blue-400 shrink-0 mt-0.5" />
              Tu conversación queda guardada en este dispositivo para darle
              seguimiento.
            </li>
          </ul>
        </div>

        <button
          onClick={onIniciar}
          className="w-full bg-blue-600 hover:bg-blue-500 text-white font-bold py-3 rounded-xl flex items-center justify-center gap-2 transition-colors"
        >
          Iniciar conversación
          <ArrowRight size={18} />
        </button>

        <p className="text-slate-500 text-[11px] text-center mt-3">
          No necesitas registrarte. La próxima vez entrarás directo a tu chat.
        </p>
      </div>
    </div>
  );
}
